import { ArchiveContactModal } from "components/ArchiveContactModal";
import { EditContactModal } from "components/EditContactModal";
import { useContacts } from "hooks/useContacts";
import { useArchiveGuard } from "hooks/useArchiveGuard";
import { useState } from "react";
import { Button } from "styles/Button";

export function ArchiveButton() {
  const [isOpen, setIsOpen] = useState(false);
  const [isEditContactModalOpen, setIsEditContactModalOpen] = useState(false);

  const { selectedContact } = useContacts();

  const resolveArchiveAction = useArchiveGuard();

  async function handleOpenArchiveModal() {
    const choice = await resolveArchiveAction({
      userCompanyId: selectedContact.user_company_id,
      realEstateId: selectedContact.real_estate_id,
    });

    if (choice === 'archive') setIsOpen(true);
    else if (choice === 'associate') setIsEditContactModalOpen(true);
  }

  function handleCloseArchiveModal() {
    setIsOpen(false);
  }

  function handleCloseEditContactModal() {
    setIsEditContactModalOpen(false);
  }

  return (
    <>
      <Button
        medium={!window.matchMedia("(max-width: 1366px)").matches}
        small={window.matchMedia("(max-width: 1366px)").matches}
        onClick={handleOpenArchiveModal}
      >
        Arquivar
      </Button>

      <ArchiveContactModal
        contact={{
          id: selectedContact.id,
          name: selectedContact.name,
          categoryId: selectedContact.category?.id,
          responsibleId: selectedContact.user?.id,
          session: selectedContact.session,
          userCompanyId: selectedContact.user_company_id,
          realEstateId: selectedContact.real_estate_id,
        }}
        isOpen={isOpen}
        onRequestClose={handleCloseArchiveModal}
      />

      <EditContactModal
        isOpen={isEditContactModalOpen}
        onRequestClose={handleCloseEditContactModal}
        contactToEdit={selectedContact}
      />
    </>
  );
}
